import { TroubleshootingLabel } from '../types';
import { CommonEmotionAI } from './CommonEmotionAI';
import { PageView } from './hit/PageView';
export class EmotionAI extends CommonEmotionAI {
    cleanup() {
        this._isEAIDataCollecting = false;
    }
    async processPageView(currentPage) {
        const pageView = new PageView(currentPage);
        await this.reportPageView(pageView);
    }
    async startCollectingEAIData(visitorId, currentPage) {
        this._isEAIDataCollecting = true;
        this._startCollectingEAIDataTimestamp = Date.now();
        this._onEAICollectStatusChange?.(true);
        if (currentPage) {
            await this.processPageView(currentPage);
        }
        this.sendCollectingTroubleshooting(this._startCollectingEAIDataTimestamp, TroubleshootingLabel.EMOTION_AI_STOP_COLLECTING);
        this.sendCollectingUsageHit(TroubleshootingLabel.EMOTION_AI_START_COLLECTING);
    }
    removeListeners() {
        this._onEAICollectStatusChange?.(false);
    }
}
